import { Observable } from 'rxjs';

import { Brand, CrisRequest, KnpPaginationData, User } from 'app/model';
import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';

class CrisRequestService extends RestfulApiService<CrisRequest> {
    public saveForSeamOnly(entity: ModelWithoutId<CrisRequest>): Observable<CrisRequest> {
        const data: Record<string, unknown> = {};
        data[this.getFormName()] = this.prepareSaveData(entity);

        return this.http.post<CrisRequest>(this.getUrl(), data, { params: { seamOnly: 1 } });
    }

    public deleteAndTransfer(entity: CrisRequest, target: string): Observable<void> {
        return this.http.delete(this.getAlterUrl(entity), { body: { target } });
    }

    public execute(data: CrisRequest) {
        return this.http.post<CrisRequest>(`${this.getAlterUrl(data)}/execute`);
    }

    public reassign(data: CrisRequest, user: User) {
        return this.http.post<CrisRequest>(`${this.getAlterUrl(data)}/reassign`, { user: user.id });
    }

    public findDupes(name?: string, brand?: Brand): Observable<KnpPaginationData<CrisRequest>> {
        return this.http.get<KnpPaginationData<CrisRequest>>(`${this.getUrl()}/dupes`, {
            params: { cris_dupe: { name, brand: brand?.id } },
        });
    }

    protected getFormName(): string {
        return 'cris_workflow';
    }

    protected getPath(): string {
        return 'cris-workflows';
    }

    protected prepareSaveData(entity: ModelWithoutId<CrisRequest>): ModelPrepped<CrisRequest> {
        return {
            ...entity,
            brand: entity.brand?.id,
            owner: entity.owner?.id,
        };
    }
}

export const crisRequestService = new CrisRequestService();
